import axios from "axios"

const getGuide = (order) => {
  return axios
    .get(`/label/${order._id}`)
    .then((response) => {
      //console.log("response from token auth", response.status)
      return response.data
    })
    .catch((/* response */) => {
      //acctions in case of error in server
      //console.log("rerrr", response)
      return null
    })
}
const cancelShipment = (order) => {
  const headers = {
    "Content-Type": "application/json"
  }

  const { _id, shipping_method } = order

  return axios
    .delete(`/shipping/${shipping_method}/cancel/${_id}`, {
      headers: headers
    })
    .then((response) => {
      return response.data
    })
    .catch(() => {
      return null
    })
}

const createLabel = (
  shipping_method,
  order_id,
  packageIndex,
  isReturn,
  forceRateFetch = false
) => {
  const headers = {
    "Content-Type": "application/json"
  }

  return axios
    .post(
      `/shipping/labels/create`,
      {
        shippingMethod: shipping_method,
        orderId: order_id,
        packageIndex: `${packageIndex}`,
        isReturn: isReturn,
        forceRateFetch
      },
      {
        headers: headers
      }
    )
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      console.error("Label creation failed:", {
        message: error.message,
        status: error.response?.status,
        code: error.code
      })
      return null
    })
}

export const schedulePickUp = (order) => {
  return axios
    .get(`/pickUp/${order._id}`)
    .then((response) => {
      //console.log("response from token auth", response.status)
      return response.data
    })
    .catch((/* response */) => {
      //acctions in case of error in server
      //console.log("rerrr", response)
      return null
    })
}

const getObjects = (collectionDBname) => {
  return axios
    .get(`/${collectionDBname}`)
    .then((response) => {
      //console.log("response from token auth", response.status)
      return response.data
    })
    .catch((/* response */) => {
      //acctions in case of error in server
      //console.log("rerrr", response)
      return null
    })
}

const getObjectsPage = (collectionDBname, page, sortParams = {}) => {
  return axios
    .get(`/${collectionDBname}/listing/${page}`, { params: sortParams })
    .then((response) => {
      //console.log("response from token auth", response.status)
      return response.data
    })
    .catch((/* response */) => {
      //acctions in case of error in server
      //console.log("rerrr", response)
      return null
    })
}

const getObjectsNotLogged = (collectionDBname) => {
  return axios
    .get(`/${collectionDBname}/shape`)
    .then((response) => {
      //console.log("response from token auth", response.status)
      return response.data
    })
    .catch((/* response */) => {
      //acctions in case of error in server
      //console.log("rerrr", response)
      return null
    })
}
const updateObject = (collectionDBname, object) => {
  //body

  const headers = {
    "Content-Type": "application/json"
    //Authorization: `Bearer ${token}`,
  }

  return axios
    .put(`/${collectionDBname}/${object._id}`, object, {
      headers: headers
    })
    .then((response) => {
      //console.log("response from server", response.status, response.data)

      return response.data
    })
    .catch((/* response */) => {
      //acctions in case of error in server
      //console.log("rerrr", response)
      return null
    })
}
const createObject = (collectionDBname, object) => {
  //body

  const headers = {
    "Content-Type": "application/json"
    //Authorization: `Bearer ${token}`,
  }

  return axios
    .post(`/${collectionDBname}`, object, {
      headers: headers
    })
    .then((response) => {
      //console.log("response from server", response, response.data)

      return response.data
    })
    .catch((/* response */) => {
      //acctions in case of error in server
      //console.log("rerrr", response)
      return null
    })
}
const deleteObject = (collectionDBname, object) => {
  //body

  const headers = {
    "Content-Type": "application/json"
    //Authorization: `Bearer ${token}`,
  }

  return axios
    .delete(`/${collectionDBname}/${object._id}`, {
      headers: headers
    })
    .then((response) => {
      //console.log("response from server", response.status, response.data)

      return response.data
    })
    .catch((/* response */) => {
      //acctions in case of error in server
      //console.log("rerrr", response)
      return null
    })
}
const getDepartments = () => {
  return axios
    .get("/departamentos")
    .then((response) => {
      return response.data
    })
    .catch((/* response */) => {
      //acctions in case of error in server
      //console.log("rerrr", response)
      return null
    })
}
const getCities = (c_digo_dane_del_departamento) => {
  //console.log("before back", axios)
  return axios
    .get(`/departamentos/${c_digo_dane_del_departamento}`)
    .then((response) => {
      //console.log("cities from back", response)
      return response.data
    })
    .catch((/* response */) => {
      //acctions in case of error in server
      //console.log("rerrr", response)
      return null
    })
}

const seedSite = ({ locale_id }) => {
  return axios
    .post(`/sites/seed`, {
      locale_id
    })
    .then((response) => {
      return response.data
    })
    .catch((/* response */) => {
      //console.log("rerrr", response)
      return null
    })
}

const DEFAULT_PAGE_SIZE = 24

const getPaginatedList = async (collectionDBname, page, params = {}) => {
  try {
    const response = await axios.get(`/${collectionDBname}/listing`, {
      params: { page, limit: DEFAULT_PAGE_SIZE, ...params }
    })
    const { items, pagination } = response.data.data
    return {
      items,
      total: pagination?.total ?? 0
    }
  } catch (error) {
    console.error(`Error fetching ${collectionDBname} paginated list:`, {
      message: error.message,
      status: error.response?.status,
      code: error.code
    })
    return null
  }
}

const getAllObjects = (collectionDBname) => {
  return getPaginatedList(collectionDBname, 1, { limit: -1 })
}

export default {
  getGuide,
  cancelShipment,
  getDepartments,
  getCities,
  updateObject,
  createObject,
  deleteObject,
  getObjects,
  getObjectsPage,
  getObjectsNotLogged,
  seedSite,
  createLabel,
  getPaginatedList,
  getAllObjects
}
